import * as React from "react";
const SvgFilter = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "3 6 18 12", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" }));
export default SvgFilter;
